import { Location } from 'history'

type Props = Pick<Location, 'hash' | 'pathname' | 'search'>

export const getLoginRedirectUrl = ({ hash, pathname, search }: Props) =>
  search.includes('redirect')
    ? `/login${search}`
    : `/login?redirect=${pathname}${search.replace('?', '&')}${hash}`

export const getSearchRedirectUrl = ({ hash, pathname, search }: Props) =>
  search.includes('redirect')
    ? search
    : `?redirect=${pathname}${search.replace('?', '&')}${hash}`
